import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavbarComponent } from './navbar/navbar.component';
import { MainSidebarComponent } from './main-sidebar/main-sidebar.component';
import { ContentHeaderComponent } from './content-header/content-header.component';
import { RouterModule } from '@angular/router';
import { ReplaceParamsPipe } from './content-header/replace-params.pipe';
import { LoadingComponent } from './loading/loading.component';
import { MainFooterComponent } from './main-footer/main-footer.component';
import { AdminLayoutComponent } from './admin-layout/admin-layout.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AppUpdateDialogComponent } from './app-update-dialog/app-update-dialog.component';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { BreadcrumbModule } from '@syncfusion/ej2-angular-navigations';
import { SkeletonModule } from '@syncfusion/ej2-angular-notifications';



@NgModule({
  declarations: [NavbarComponent, 
    MainSidebarComponent, 
    ContentHeaderComponent, 
    ReplaceParamsPipe, 
    LoadingComponent, 
    MainFooterComponent, 
    AdminLayoutComponent, 
    AppUpdateDialogComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([]),
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    BreadcrumbModule,
    SkeletonModule
  ],
  exports: [
    NavbarComponent,
    MainSidebarComponent,
    ContentHeaderComponent,
    MainFooterComponent,
    AdminLayoutComponent,
    AppUpdateDialogComponent
  ]
})
export class CoreModule { }
